import React, { Component } from "react";
import InputForm from "../../../../common/components/html/inputForm";
import RadiobuttonForm from "../../../../common/components/html/radiobuttonForm";
import SelectForm from "../../../../common/components/html/selectForm";
import commonContext, { AppContext } from "../../../../common/context/common";
import Profession from "../../../../common/constents/profession";
import Industry from "../../../../common/constents/industry";
import { leadType } from "../../../../app";

interface IProps {}
interface IState {}
export default class EmploymentDetailsCard extends Component<IProps, IState> {
    static contextType = commonContext;
    setLead: Function;
    apis: any;
    lead: leadType;
    base: any;
    async componentDidMount() {
        this.setLead = (this.context as AppContext).setLead;
        this.apis = (this.context as AppContext).apis;
    }
    handleOnChange = (e: any) => {
        let state = {};
        state[e.target.name] = e.target.value;
        this.setLead(state);
    };
    handleOnStateChange = async (e: any) => {
        this.setLead({
            citysList: [],
        });
        const apiData = await this.apis.getCities({
            ...this.lead,
            state: e.target.value,
        });
        this.setLead({
            citysList: apiData.result,
        });
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.base = (this.context as AppContext).base;
        return (
            <>
                <div className="w-full reg-emp-details-wrap">
                    <h2 className="openSans-Reg text-black my-8 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                        Employment Details
                    </h2>
                    <div className="flex flex-wrap w-full">
                        {this.base == "zd-10-seconds" ||
                        this.base == "qm-10-seconds" ? (
                            <>
                                <div className="relative w-full mb-5">
                                    <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500">
                                        Employment Status
                                    </label>
                                    <ul className="button-radio emp-status-input">
                                        <li>
                                            <RadiobuttonForm
                                                label="Salaried"
                                                name="edConstitution"
                                                value="Salaried"
                                            />
                                        </li>
                                        <li>
                                            <RadiobuttonForm
                                                label="Self-employed"
                                                name="edConstitution"
                                                value="Self-employed"
                                            />
                                        </li>
                                    </ul>
                                </div>
                            </>
                        ) : (
                            ""
                        )}
                        <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                            <InputForm
                                label="Name of Company"
                                errorText="Please enter Name of Company"
                                name="edCompanyName"
                                handlerOnChange={(e) => this.handleOnChange(e)}
                                value={this.lead.edCompanyName}
                                readonly={this.base == "dd-al" ? true : false}
                            />
                        </div>

                        <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                            <SelectForm
                                title="Profession"
                                noneText="Select Profession"
                                errorText="Please select Profession"
                                options={Profession}
                                name="edProfession"
                                handlerOnChange={(e) => this.handleOnChange(e)}
                                value={this.lead.edProfession}
                                readonly={this.base == "dd-al" ? true : false}
                            />
                        </div>

                        <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                            <SelectForm
                                title="Industry"
                                noneText="Select Industry"
                                errorText="Please enter Industry"
                                options={Industry}
                                name="edIndustry"
                                handlerOnChange={(e) => this.handleOnChange(e)}
                                value={this.lead.edIndustry}
                                readonly={this.base == "dd-al" ? true : false}
                            />
                        </div>

                        <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                            <InputForm
                                label="Pincode"
                                errorText="Please enter Pincode"
                                name="edOfficePinCode"
                                handlerOnChange={(e) => this.handleOnChange(e)}
                                value={this.lead.edOfficePinCode}
                                readonly={this.base == "dd-al" ? true : false}
                            />
                        </div>

                        <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                            <SelectForm
                                title="State"
                                noneText="Select State"
                                errorText="Please enter state"
                                options={this.lead.statesArray}
                                name="edOfficeState"
                                objectKey="state"
                                handlerOnChange={(e) => {
                                    this.handleOnChange(e);
                                    this.handleOnStateChange(e);
                                }}
                                value={this.lead.edOfficeState}
                                readonly={this.base == "dd-al" ? true : false}
                            />
                        </div>
                        <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                            <SelectForm
                                title="City"
                                noneText="Select City"
                                errorText="Please enter City"
                                options={this.lead.citysList}
                                name="edOfficeCity"
                                objectKey="city"
                                handlerOnChange={(e) => this.handleOnChange(e)}
                                value={this.lead.edOfficeCity}
                                readonly={this.base == "dd-al" ? true : false}
                            />
                        </div>
                        <div className="relative flex flex-wrap w-full">
                            <label className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base text-gray-500 w-full">
                                Work Address
                            </label>
                            <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                                <InputForm
                                    name="edOfficeAddress"
                                    handlerOnChange={(e) =>
                                        this.handleOnChange(e)
                                    }
                                    value={this.lead.edOfficeAddress}
                                    readonly={
                                        this.base == "dd-al" ? true : false
                                    }
                                />
                            </div>
                            <div className="relative w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4 lg:pl-4 xl:pl-4">
                                <InputForm
                                    name="edOfficeAddress2"
                                    handlerOnChange={(e) =>
                                        this.handleOnChange(e)
                                    }
                                    value={this.lead.edOfficeAddress2}
                                    readonly={
                                        this.base == "dd-al" ? true : false
                                    }
                                />
                            </div>
                            {this.lead.edOfficeAddress3 ? (
                                <div className="relative w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4 lg:pr-4 xl:pr-4">
                                    <InputForm
                                        name="edOfficeAddress3"
                                        handlerOnChange={(e) =>
                                            this.handleOnChange(e)
                                        }
                                        value={this.lead.edOfficeAddress3}
                                        readonly={
                                            this.base == "dd-al" ? true : false
                                        }
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                            <span className="hidden error-msg text-red-600 openSans-Reg text-xs md:text-sm lg:text-sm xl:text-sm">
                                Please enter Work Address
                            </span>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
